export enum RequestState {
  UNSENT,
  SENDING,
  SENT_SUCCESS,
  SENT_FAILED,
}
